import React, { useEffect, useState, useRef } from 'react';
import { SwiperControl } from '../SwiperControl.js';
import { NavLink } from 'react-router-dom';
import { listTypes, urls, paginationSettings } from '../../constants.js';
import { loadListData, renderDocumentItem, subscribeToSignEvents } from '../helpers/HelperFunctions.js';
import i18next from "../../i18n.js";

const LastItemsWidget = (props) => {
    const [items, setItems] = useState([]);
    const [fieldSettings, setFieldSettings] = useState(null);

    const documentsInSigningRef = useRef([]);

    useEffect(() => {
        const orderBy = props.type === listTypes.Documents ? 'CreateDate' : '';
        const filter = props.type !== listTypes.Tasks ? [{
            name: 'Creator',
            values: ['ME']
        }] : [];
        loadListData(props.type, filter, 0, paginationSettings.swiperItenmsCount, orderBy, true).then(data => {
            if (data && data.items) {
                setFieldSettings(data.fieldSettings);
                setItems(data.items);
            }
        });

        let unsubscribeFunction = null;

        if (props.type === listTypes.Tasks) {
            unsubscribeFunction = subscribeToSignEvents(documentsInSigningRef);
        }

        return () => {
            if (unsubscribeFunction) {
                unsubscribeFunction();
            }
        }
        
    }, []);

    const GetTitle = () => {
        switch (props.type) {
            case listTypes.Documents:
                return i18next.t("widgets.myDocumentsTitle");
            case listTypes.Tasks:
                return i18next.t("widgets.myTasksTitle");
            default:
                return "";
        }
    }

    const GetTitleLink = () => {
        switch (props.type) {
            case listTypes.Documents:
                return urls.documentsPage;
            case listTypes.Tasks:
                return urls.tasksPage;
            default:
                return "#";
        }
    }

    if (items && items.length > 0) {
        return (<div className="widget last-items">
            <div className="last-items-title">
                <NavLink to={GetTitleLink()}>{GetTitle()}</NavLink>
            </div>
            <SwiperControl items={items} itemComponent={({ item }) => renderDocumentItem(item, props.type, fieldSettings)} showArrows={true} />
        </div>);
    }
    else {
        return <></>
    }
}

export default LastItemsWidget;